import { Icon } from '@ui/themed';

type ChecklistItemProps = {
  title: string;
  description: string;
};

export function ChecklistItem({ title, description }: ChecklistItemProps) {
  return (
    <div className="flex">
      <div className="shrink-0">
        <div className="flex items-center justify-center">
          <span className="flex size-5 items-center justify-center rounded-full bg-spark-accent-solid text-spark-text-inverse">
            <Icon name="check" size="xs" />
          </span>
        </div>
      </div>
      <div className="-mt-0.5 ml-3">
        <dt className="font-medium text-m text-spark-text-primary leading-6">{title}</dt>
        <dd className="mt-1 text-sm text-spark-text-secondary">{description}</dd>
      </div>
    </div>
  );
}
